import React, { useState } from 'react';

function EyeIcon({ open }) {
  if (open) {
    return (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
        <line x1="1" y1="1" x2="23" y2="23" />
      </svg>
    );
  }
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function passwordRules(password) {
  return {
    length: password.length >= 8,
    upper: /[A-Z]/.test(password),
    lower: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };
}

export function PasswordField({
  id,
  label,
  value,
  onChange,
  placeholder,
  autoComplete,
  showRules = false,
  hint,
}) {
  const [visible, setVisible] = useState(false);
  const rules = passwordRules(value);

  return (
    <div className="provider-form-group">
      <label htmlFor={id} className="provider-label">
        {label}
      </label>
      <div className="provider-input-wrap">
        <input
          type={visible ? 'text' : 'password'}
          id={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          className="provider-input"
          required
        />
        <button
          type="button"
          className="provider-input-toggle"
          onClick={() => setVisible(!visible)}
          aria-label={visible ? 'Hide password' : 'Show password'}
        >
          <EyeIcon open={visible} />
        </button>
      </div>
      {hint && <p style={{ margin: '6px 0 0', fontSize: 13, color: 'var(--color-text-muted)' }}>{hint}</p>}
      {showRules && (
        <ul className="provider-password-rules">
          <li className={rules.length ? 'met' : ''}>8+ characters</li>
          <li className={rules.upper ? 'met' : ''}>Uppercase</li>
          <li className={rules.lower ? 'met' : ''}>Lowercase</li>
          <li className={rules.number ? 'met' : ''}>Number</li>
          <li className={rules.special ? 'met' : ''}>Special char</li>
        </ul>
      )}
    </div>
  );
}

export default PasswordField;
